import { isAfter, parse, startOfDay } from 'date-fns';

export const getRelevantEventDay = (eventDays) =>
  eventDays.find(
    (eventDay) =>
      parse(eventDay.date + eventDay.endTime, 'yyyy-MM-ddHH:mm', new Date()) > new Date()
  );

export const getIsRegistrationExpired = (event) => {
  if (!event?.registrationDeadline) return false;

  const deadline = startOfDay(new Date(event.registrationDeadline));
  const today = startOfDay(new Date());

  if (Number.isNaN(deadline.getTime())) return false;

  return isAfter(today, deadline);
};
